export enum ExtraServicePaxType {
  INF = 'INF',
  CHD = 'CHD',
  ADT = 'ADT',
}
